import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SkipSelf,
} from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { State, US_STATES } from '../us-states';

export interface Address {
  address: string;
  address2?: string;
  city: string;
  state: string;
  zip: string;
}

@Component({
  selector: 'app-address-subform',
  templateUrl: './address-subform.component.html',
  styleUrls: ['./address-subform.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer) => container,
      deps: [[new SkipSelf(), ControlContainer]],
    },
  ],
})
export class AddressSubformComponent implements OnInit {
  @Input() address: string = '';
  @Input() address2: string = '';
  @Input() city: string = '';
  @Input() state: string = '';
  @Input() zip: string = '';
  @Input() required = false;
  @Output() addressChange = new EventEmitter<Address>();

  states: State[] = US_STATES;

  constructor() {}

  ngOnInit(): void {}

  // Emit event when any field changes
  emitAddressChange(): void {
    const addressData: Address = {
      address: this.address,
      address2: this.address2,
      city: this.city,
      state: this.state,
      zip: this.zip,
    };

    this.addressChange.emit(addressData);
  }
}
